module.exports = __webpack_public_path__ + "static/media/breno.799845e4.jpeg";